import * as types from './actionTypes';

export const updateTheme = theme => ({
  type: types.UPDATE_THEME,
  theme,
});

// fetch Theme
export function fetchThemeSuccess({ data }) {
  return {
    type: types.FETCH_THEME_SUCCESS,
    data,
  };
}
export function fetchThemeFail({ error }) {
  return {
    type: types.FETCH_THEME_FAIL,
    error,
  };
}
